import { Application } from "@hotwired/stimulus"
const application = Application.start()

// Import and register all Stimulus Controllers supporting our view components
import Banner from './controllers/banner_controller'
import Button from './controllers/button_controller'
import ButtonDemo from './controllers/button_demo_controller'
import Dropdown from './controllers/dropdown_controller'
import Hello from './controllers/hello_controller'
import Message from './controllers/message_controller'
import Collapsible from './controllers/collapsible_controller'
import Scrollable from './controllers/scrollable_controller'

function registerKuyioControllers(application) {
  application.register('kuyio-banner', Banner)
  application.register('kuyio-button', Button)
  application.register('kuyio-button-demo', ButtonDemo)
  application.register('kuyio-dropdown', Dropdown)
  application.register('kuyio-hello', Hello)
  application.register('kuyio-message', Message)
  application.register('kuyio-collapsible', Collapsible)
  application.register('kuyio-scrollable', Scrollable)
}

registerKuyioControllers(application)

export { registerKuyioControllers }